export default "__VITE_ASSET__Be4QJivo__"